import type { ShopMegaMenuData } from '@/types/api/shop-mega-menu'

// Both navs ask the same question of the same data — "is there a panel to
// open?" — so they ask it in one place. No curated links means Shop stays a
// plain link to the shop; a failed fetch arrives as null and lands here too.
export const hasShopMegaMenuLinks = (data?: ShopMegaMenuData | null) =>
  !!data?.columns.some((column) => column.length)

// The two-column split is a desktop layout. Anywhere the links are read as one
// list (the mobile panel), they are read through this.
export const shopMegaMenuLinks = (data: ShopMegaMenuData) => [
  ...data.columns[0],
  ...data.columns[1],
]
